import { LunaCodeNode } from "./rules.model";
import { EntityMap } from "../../builder/models/entity.model";

import { WorkOrder, WorkOrderWithAssignments, WorkOrderType } from "./work-order.model";
import { Organization } from "./organization.model";
import { Group } from "../../admin/models/group.model";
//import { LabelSize, LabelFormat } from "./certified-mail.model";
import { AddressDomain } from "../../builder/models/domain.model";
import { SignerType, ContactStub } from "../../admin/models/contact.model";
import { Note } from "../../common/models/note.model";

import * as model from "../../flow/models/flow.model";

import { INoteable } from "./noteable.interface";
import { ReportTemplate } from "../../models/comodel/mergefieldsmodel.model";

export interface NavigationRecord {
    section: number,
    page: number,
    absolutePageIndex: number;
}



export interface FlowIndex{
    applicationCompleteDate?: string;
    flowId: string;
    flowTemplateId: string;
    name: string;
    createdById: string;
    userName: string;
    state: string;
    organizationId?: string;
    companyName?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    dateSubmitted?: Date;
    submittedDate?: Date;
    flowIdentifier: string;
    identifierType: string;
    partitionKey: string;
    rowKey: string;
    timestamp: Date;
    eTag: string;
    currentWorkItemId?: string;
    assignedUserId: string;
    assignedUserName: string;
    assignedGroupId: string;
    assignedGroupName: string;
    lastSubmitDate?: Date;
    approvedDate?: Date;
    rejectedDate?: Date;
    onBehalf?: boolean;
    ejectedIncomplete?: Date;
    isInputState?: boolean;
    isReviewState?: boolean;
    isEndState?: boolean;
    isStartState?: boolean;
    isReturned?: boolean;
    properties: any;

}

export enum PageType {
    Input = "input",
    Summary = "summary",
    ReviewComments = "reviewComments",
    NewCasingPlan = "newCasingPlan",
    EditCasingPlan = "editCasingPlan",
    PaymentCheckout = "paymentCheckout",
    PaperScanning = "paperScanning"
}

export enum StateType {
    Undefined = "",
    Start = "start",
    InputForm = "inputForm",
    End = "end",
    ReviewForm = "reviewForm"
}

export enum EntryType {
    Undefined = "Undefined",
    Submission = "Submitted",
    ReviewApproval = "Approved",
    ReviewRejected = "Rejected",
    ReturnedToSubmitter = "Returned To Submitter",
    Approval = "Approved",
    Completed = "Completed",
    Waiting = "Pending",
    WaitingOnUser = "Waiting On Submitter",
    LetterGenereted = "Letter Generated",
    LetterMailed = "Letter Mailed",
    DocumentScanned = "Document Scanned",
    PaymentPosted = "Payment Posted",
    Initiated = "Initiated",
    ChiefsOrderAppealed = "Chief's Order Appealed",
    ChiefsOrderIssued = "Chief's Order Issued",
    ChiefsOrderModified = "Chief's Order Modified",
    ChiefsOrderRevoked = "Chief's Order Revoked",
    ChiefsOrderSuspended = "Chief's Order Suspended",
    ChiefsOrderTerminated = "Chief's Order Terminated",
    ChiefsOrderVacated = "Chief's Order Vacated",
    PaymentReceived = "Payment Received",
    ApplicationComplete = "Application Complete",
    NoteAdded = "Note Added"
}

export enum HistoryType {
    Flow,
    WorkOrder,
}

export interface FlowHistory {
    id: string;
    instanceId: string;
    userId: string;
    organizationId: string;
    workOrderId: string;
    entryType: EntryType;
    date: string;
    type: HistoryType;
}

export interface DetailedFlowHistory extends FlowHistory {
    userInfo: ContactStub,
    workItem: WorkOrder,
    organization: Organization;
    group: Group;
}

export interface FlowStub {
    name?: string;
    id?: string;
}


export interface FlowInstance extends FlowStub {
    templateId?: string;
    templateName?: string;
    organizationId?: string;
    userId?: string;
    currentState?: string;
    previousState?: string;
    states?: State[];
    currentWorkItem?: string;
    associatedWorkItems?: WorkOrderWithAssignments[];
    history?: DetailedFlowHistory[];
    isPublic: boolean;
    startAtSummary: boolean;
    onBehalf?: boolean;
    isReturned?: boolean;
}

export interface FlowTemplate extends FlowInstance {
    entityMaps?: EntityMap[];
    context: FlowContextTemplate;
    workflowId?: string;
    majorVersion?: number;
    minorVersion?: number;
    effectiveDate?: Date;
    isPublished?: boolean;
    model?: any;
    editorName?: string;
}

export interface WrappedFlow {
    instance: FlowInstance,
    context: any;
}

export interface FlowContextTemplate {
    model?: any,
    rules: ChangeTargetRule[];
}

export interface State {
    name?: string;
    title?: string;
    isInitial?: boolean;
    isTerminal?: boolean;
    transitions?: Transition[];
    key?: number;
    sections?: Section[];
    stateType: StateType;
}

export interface Section {
    id: string,
    name?: string;
    isRequired?: Rule;
    pages?: Page[];
    isEditing?: boolean;
}

export interface Transition {
    name?: string;
    fromStateKey?: number;
    toStateKey?: number;
    gojsKey?: number;
    targetState?: string;
    key?: string;
    sideEffects?: SideEffect[];
    outgoingRules: ChangeTargetRule[];
}

export interface Rule {
    ruleId: string;
    name: string;
    expression?: string;
    parseTree?: LunaCodeNode;
}

export interface ChangeTargetRule extends Rule {
    contextTarget: string;
    condition?:string;
}



export interface SideEffect {
    id?: string;
    label?: string;
    configuration?: any;
    implementationType?: SideEffectType;
    runOrder?: number;
    runCondition: string;
    runOnce?: boolean;
    hasRunIndicator?: string;
}

export interface Page {
    pageNumber: number;
    pageType: PageType;
    subtitle?: string;
    questions?: Question[][];
    section: string;
    buttons?: Button[];
    incomingRules: ChangeTargetRule[];
    isSectionHead?: boolean;
}

export interface ValidationRule extends Rule {
    message: string;
    key: string;
    onSubmitOnly?: boolean;
}

export interface Question extends INoteable {
    key?: string;
    label?: string;
    helpText?: string;
    config?: any;
    type?: QuestionKind;
    defaultValue: any;
    contextTarget?: string;
    initialDataContextTarget?: string;
    initialDataContextTargetRule?: Rule;
    enabledRule?: Rule;
    validationRules: ValidationRule[];
    visibleRule?: Rule;
    changeRules: ChangeTargetRule[];
    flexGrow?: number;
    //files: string[];
}

export interface PublishInfo {
    effectiveDate?: Date;
    majorVersion?: number;
    minorVersion?: number;
    id?: string;
}

export interface Button {
    id: string,
    position: ButtonPosition,
    label: string;
    type: ButtonKind;
    visibleRule?: Rule;
    enabledRule?: Rule;
    notifyMessageRule?: Rule,
    redirectToRule?:Rule,
    targetPageRule?: Rule; // number / page index in the form
    targetSectionRule?: Rule;
    targetTransitionRule?: Rule; // string / name of transition in the current state
    disableTypeChange: boolean;
    special?: boolean;
    confirmAction?: boolean;
    restrictingGroups?: string[];
    alwaysEnable?: boolean;
}

export enum ButtonKind {
    Unset = 'unset',
    Next = 'next',
    Back = 'back',
    Transition = 'transition',
    JumpToPage = 'jump',
    JumpToSection = 'jumpSection',
    Approve = 'approve',
    Return = 'return',
    AddReviewer = "adhoc",
    UpdateWorkItem = "updateWorkItem"
}

export enum QuestionKind {
    Textbox = 'textbox',
    Combo = 'combo',
    Dropdown = 'dropdown',
    Checkbox = 'checkbox',
    Radio = 'radio',
    Label = 'label',
    ItemList = 'list',
    Group = 'group',
    FileUpload = 'fileupload',
    TextArea = 'textarea',
    Summary = "summary",
    NewCasingPlan = "newCasingPlan",
    EditCasingPlan = "editCasingPlan",
    PaymentCheckout = "paymentCheckout",
    PaymentResponse = "paymentresponse",
    ReviewComments = "reviewcomments",
    Empty = 'empty',
    ButtonLink = 'buttonlink',
    YesNoToggle = 'yesnotoggle',
    MultiselectCheckbox = 'multiselectcheckbox',
    ESignature = 'esignature',
    ReportHeaderImage = 'reportheaderimage',
    ReportHeaderDefault = 'reportheaderdefault',
    ReportFooterDefault = 'reportfooterdefault',
    PdfGenerator = "pdfgenerator",
    CertifiedMailLabelGenerator = "certifiedmaillabelgenerator",
    ChiefsSignature = "chiefssignature",
    ReportSelector = 'reporttemplateselector',
    ReportTemplateEditor = 'reporttemplateeditor',
    ReportPdfView = 'reportpdfview',
    MapControl = 'mapcontrol',
    RouteControl = 'routecontrol',
    DataQueryButton = 'dataquerybutton',
    PhoneInput = 'phoneinput',
    FlowDataTable = 'flowdatatable',
    CasingPlanGrid ='casingPlanGrid',
    PdfViewer = 'pdfviewer',
    AreaOfReviewMap = 'areaofreviewmap',
    DatePicker = 'datepicker',
    ListEntry = 'listentry',
    CasingPlanSchematic = "casingPlanSchematic",
    FileParser = "fileParser",
    BulkWellTransferParser = "bulkWellTransferParser"
}

export enum ButtonPosition {
    Left = 'left',
    Right = 'right',
    Special = 'special'
}

export enum RuleEvent {
    None = -1,
    OnInputChange = 0,
    OnPageEnter = 1,
    OnFormComplete = 2
}

export enum RuleAction {
    None = -1,
    EnableQuestion = 0,
    UpdateContext = 1,
    ShowQuestion = 2
}

export enum ButtonRuleType {
    None = -1,
    Visible = 0,
    Enabled = 1,
    Target = 2,
    NotifyMessage = 3,
    RedirectTo = 4
}

export interface Option {
    id: string;
    idNumeric?: number;
    text: string;
}

export enum BodyType {
    HTML,
    Text
}

export enum ReportDeliveryMethod {
    Undefined = "undefined",
    Email = "email",
    CertifiedMail = "certifiedMail"
}
export interface TextTemplateRuleWithOnBaseKeywordName extends Rule {
    onBaseKeywordName: string;
    compiledValue: string;
}
export interface TextTemplate {
    id:string;
    content:string;
    transforms: TextTemplateRuleWithOnBaseKeywordName[];
    codedTemplate:boolean;
  }
export interface SendLetterConfig {
    title: string;
    template: TextTemplate;
    recipient: SnailMailAddress;
    office: SnailMailAddress;
    
    documentType: {
        value: string;
        displayName: string;
    };
    organizationIdRule: string;
    applicationNumberRule: string;

    onBaseDocumentGroupName: string;
    onBaseDocumentTypeName: string;
    onBaseFileName: string;

    sendCertified:boolean;
    documentIdPath:string;
}

export interface SnailMailAddress {
    title: string;
    name1: string;
    name2: string;
    name3: string;
    address1: string;
    address2: string;
    address3: string;
    city: string;
    state: string;
    zipCode: string;
    zipPlus4: string;
}
export interface TagConfiguration {
    tagId: string;
    valueRule: string;
}

export interface SendEmailConfig {
    subject: TextTemplate;
    body: TextTemplate;
    toAddressRules: Rule[];
    ccAddressRules: Rule[];
    bccAddressRules: Rule[];
}
export interface GenerateIdentifierConfig {
    identifierType: string;
    contextTarget: string;
}
export interface ReportConfig {
    reportMap: string;
    template: ReportTemplate;
    emailConfig: SendEmailConfig;
    deliveryMethod: ReportDeliveryMethod;
}

export interface SaveDataConfig {
    entityMapIds: Array<string>;
    entities: Array<SaveDataSettings>;
}

export interface SaveDataSettings {
    mapId: string;
    isPreview: boolean;
    parentMapId: string;
    previewContext: string;
    relatedEntities: Array<SaveDataSettings>;
    saveEntity: boolean;
}

export interface LoadFromDatabaseConfig {
    entityMapIds: Array<string>;
}

export interface EmailAddress {
    addressType: EmailAddressType;
    id: string;
    address: string;
}

export enum EmailAddressType {
    Unassigned,
    Context,
    Group,
    Contact
}

export interface StartAnotherWorkFlowConfig {
    organizationId: string;
    templateId: string;   
    newTemplateIdPath: string;
    currentTemplateIdPath: string;
}

export interface SetDueDtAndApproveDtConfig {
    identifierType: string;
    contextTarget: string;
}

export interface ModifyOtherWorkFlowContextConfig {
    otherworkflowIdExpression: string;
    transform: Rule[]; 
}

export interface InvokeTransitionOnOtherWorkflowConfig{
    otherWorkflowIdRule:string;
    otherWorkflowTransitionRule:string;
    otherWorkflowContextShouldInvokeRule:string;
}

export interface TransformContextConfig{
    transforms: ChangeTargetRule[];
}

export enum SideEffectType {
    Unassigned = "",
    SaveToDatabase = "SaveToDatabase",
    LoadFromDatabase = "LoadFromDatabase",
    Email = "SendEmail",
    Letter = "SendLetter",
    Hold = "hold",
    AssignGroup = "AssignGroup",
    AssignUser = "AssignUser",
    StartWorkflow = "StartWorkflow",
    StartAnotherWorkFlow = "StartAnotherWorkFlow",
    ModifyOtherWorkFlowContext = "ModifyOtherWorkFlowContext",
    ReviewTasks = "ReviewTasks",
    CompleteWorkItem = "CompleteWorkItem",
    ReturnWorkItem = "ReturnWorkItem",
    CancelAssociatedWorkItems = "CancelAssociatedWorkItems",
    RejectToPrevious = "RejectToPrevious",
    CommitDocuments = "CommitDocuments",
    GenerateIdentifier = "GenerateIdentifier",
    UploadPdf = "UploadPdf",
    GenerateRegistrationCode = "GenerateRegistrationCode",
    CreateContact = "CreateContact",
    AssignToScanning = "AssignToScanning",
    FetchFASummaryResults = "FetchFASummaryResults",
    InvokeTransitionOnOtherWorkflow = "InvokeTransitionOnOtherWorkflow",
    TransformContext = "TransformContext",
    LoadContactData = "LoadContactData",
    SaveValueToEntityField = "SaveValueToEntityField",
    ChangeWellOwner = "ChangeWellOwner",
    CancelPermit = "CancelPermit",
    GenerateWellApi = "GenerateWellApiNumber",
    CreateWellFeature = "CreateWellFeature",
    DetermineWellFAOrganizationId = "DetermineWellFAOrganizationId",
    LoadOrganization = "LoadOrganization",
    DeleteNotification = "DeleteNotification",  
    SendNotification = "SendNotification",   
    SetDueDtAndApproveDt = "SetDueDtAndApproveDt",
    AssignAllOrgContactsToGroup = "AssignAllOrgContactsToGroup",
    CreateOrganizationHistoryEntry = "CreateOrganizationHistoryEntry",
    GenerateUncountedIdentifiers = "GenerateUncountedIdentifiers",
    KickOffChiefsOrder = "KickOffChiefsOrder",
	ReplaceBonding = "ReplaceBonding",
	ReleaseFinancialAssurance = "ReleaseFinancialAssurance"
}

//When adding items here remember to update CountedIdentifierKind in Luna.Model.CountedIdentifier.cs
export enum CountedIdentifierKind {
    ChiefsOrder = "ChiefsOrder",
    ChiefsOrderApplication = "ChiefsOrderApplication",
    PermittingApplication = "PermittingApplication",
    FinancialAssurance = "FinancialAssurance",
    RegistrationApplication = "RegistrationApplication",
    CancellationOfOwnership = "CancellationOfOwnership",
    OwnerNumber = "OwnerNumber",
    EmergencyResponse = "EmergencyResponse",
    InspectionRecord = "InspectionRecord",
    CitizenPortal = "CitizenPortal",
    PaymentReference = "PaymentReference",
    WellTransfer = "WellTransfer",
    Enforcement = "Enforcement",
    EDiscovery = "eDiscovery",
    DataCorrection = "DataCorrection",
    ExternalDataCorrectionRequest = "ExternalDataCorrectionRequest",
    EntityNameChange = "EntityNameChange",
    ScanRequest = "ScanRequest"
}

export interface EmailTemplate {
    id: string;
    name: string;
    body: string;
    subject: string;
    transforms: Array<Rule>;
}

export enum Direction {
    East = 'east',
    West = 'west',
    North = 'north',
    South = 'south'
}

export interface SummaryControlConfig {
    isEjectSummary?: boolean;
    isReviewForm: boolean;
    requiredDomains?: string[];
    sections: Section[] | model.Section[];
    contextValues: ContextConfig[];
    configurations: SectionConfig[];
}

export interface CasingPlanGridConfig {
    isReviewForm: boolean,
    pages: Array<Page>,
    contextValues: Array<ContextConfig>,
    configurations: Array<SectionConfig>;
}

export interface NewCasingPlanConfig {
    isReviewForm: boolean,
    pages: Array<Page>,
    contextValues: Array<ContextConfig>,
    configurations: Array<SectionConfig>;
}

export interface EditCasingPlanConfig {
    questionKey: string,
    questionLabel: string,
    isDisplayed: boolean,
    summaryDisplay: string,
    contextValue: string;
}

export interface PaymentCheckoutConfig {
    questionKey: string,
    questionLabel: string,
    isDisplayed: boolean,
    summaryDisplay: string,
    contextValue: string;
}

export interface SummaryConfig {
    alwaysShowInSummaries?: boolean;
    columnNumber?: number;
    contextValue: string;
    enabledRule?: Rule | model.RuleEvaluationFn<boolean>;
    initialDataValue?: string;
    initialValueRule?: Rule;
    isDisplayed: boolean;
    isEnabled?: boolean;
    isPending?: boolean;    
    isValid?: model.RuleEvaluationFn<boolean>;
    pageNumber?: number;
    questionConfig?: any;
    questionDomain?: string;
    questionKey: string;
    questionLabel: string;
    rowNumber?: number;
    sectionNumber?: number;
    summaryDisplay: string;
    type: QuestionKind;  
    validationRules?: ValidationRule[] | model.RuleEvaluationFn<boolean>[];
    visibleRule?: Rule | model.RuleEvaluationFn<boolean>;      
}

export interface SectionConfig {
    sectionId: string,
    sectionName: string,
    summaryItems: SummaryConfig[],
    contextItems: SummaryConfig[],
    showHeading: boolean;
    displayHeading: string,
    displayOrder?: number;
    isRequired?: Rule | model.RuleEvaluationFn<boolean>;
    isPending?: boolean;
}

export interface ContextConfig {
    startPageNumber: number,
    sectionId: string,
    sectionName: string,
    contextTarget: string;
}

export interface SectionPageIndex {
    startPageIndex: number;
    endPageIndex: number;
}

// export interface CertifiedMailConfig {
//     domain: any;
//     labelSizeOptions: LabelSize[];
//     labelFormatOptions: LabelFormat[];
//     originatingAddressOptions: AddressDomain[];
// }

export interface Signature {
    id?: string,
    userId: string,
    legalName: string,
    dateSigned?: Date,
    signerType: SignerType,
    authority: string,
    flowId: string,
    permitId?: string,
    signatureText?: string,
}

export enum WorkflowStates {
    Cancelled = "Cancelled"
}

export interface RadioButtonOption {
    id: string,
    displayOrder: number
    displayText: string,
    included: boolean,
    showsText: boolean,
    showsUpload: boolean
    standardOption: boolean
}

export interface PageView {
    sectionTitle: string;
    pageTitle: string;
    views: NoteView[];
}

export interface NoteView {
    noteContext: string;
    label: string;
    value: any;
    notes: Note[];
}

export interface PaperDocumentData {
    contentType: string;
    blobUri: string;
}


export interface EjectLetterContent {
    documents: PaperDocumentData[];
    notes: PageView[];
    organizationId: string;
    organizationName: string;
    text: string;
    workflowId: string;
}

